export const REFERRAL_QUERY_PARAMETER_KEY = `fh-referral-origin`;

export const TRY_FOR_FREE_REFERRAL_VALUE = "try-for-free";
export const LOGIN_REFERRAL_VALUE = "login";
export const PRICING_GET_STARTED_REFERRAL_VALUE = "pricing-get-started";
